
export const ARRAY_CARD_DEFAULT_COLORS = [
    {
        border:'#E0E0E0',
        background:'#FFFFFF',
        useBackgroundColor:"#FFFFFF",
        useDarkBackgroundColor:'#565656',
        isSelected:false
    },
    {
        border:'transparent',
        background:'#000000',
        useBackgroundColor:"#D8D8D8",
        useDarkBackgroundColor:'#292524',
        isSelected:false
    },
    {
        border:'transparent',
        background:'#B36ED8',
        useBackgroundColor:"#F6E9FC",
        useDarkBackgroundColor:'#6C4780',
        isSelected:false
    },
    {
        border:'transparent',
        background:'#407FDB',
        useBackgroundColor:"#CADFFF",
        useDarkBackgroundColor:'#536C91',
        isSelected:false
    },
    {
        border:'transparent',
        background:'#59C457',
        useBackgroundColor:"#CCF0CC",
        useDarkBackgroundColor:'#648A63',
        isSelected:false
    },
    {
        border:'transparent',
        background:'#F4CE58',
        useBackgroundColor:"#FFF1C5",
        useDarkBackgroundColor:'#958552',
        isSelected:false
    },
    {
        border:'transparent',
        background:'#F1A14E',
        useBackgroundColor:"#FFDFBD",
        useDarkBackgroundColor:'#9D6831',
        isSelected:false
    },
    {
        border:'transparent',
        background:'#EC5C58',
        useBackgroundColor:"#FFC8C7",
        useDarkBackgroundColor:'#DA6461',
        isSelected:false
    },
    {
        border:'transparent',
        background:'#A00001',
        useBackgroundColor:"#DEA9A9",
        useDarkBackgroundColor:'#A74647',
        isSelected:false
    },
    {
        border:'transparent',
        background:'transparent',
        url:'colour.png',
        isSelected:false
    }
]

export const ARRAY_STICKYNOTES_DEFAULT_COLORS = [
    {
        border:'transparent',
        background:'#FDF59D',
        useBackgroundColor:"#FDF59D",
        useDarkBackgroundColor:'#FDF59D',
        isSelected:false
    },
    {
        border:'transparent',
        background:'#FDE76D',
        useBackgroundColor:"#FDE76D",
        useDarkBackgroundColor:'#FDE76D',
        isSelected:false
    },
    {
        border:'transparent',
        background:'#FFB271',
        useBackgroundColor:"#FFB271",
        useDarkBackgroundColor:'#FFB271',
        isSelected:false
    },
    {
        border:'transparent',
        background:'#FF9898',
        useBackgroundColor:"#FF9898",
        useDarkBackgroundColor:'#FF9898',
        isSelected:false
    },
    {
        border:'transparent',
        background:'#FFD2F2',
        useBackgroundColor:"#FFD2F2",
        useDarkBackgroundColor:'#FFD2F2',
        isSelected:false
    },
    {
        border:'transparent',
        background:'#D1F09F',
        useBackgroundColor:"#D1F09F",
        useDarkBackgroundColor:'#D1F09F',
        isSelected:false
    },
    {
        border:'transparent',
        background:'#B2D0FE',
        useBackgroundColor:"#B2D0FE",
        useDarkBackgroundColor:'#B2D0FE',
        isSelected:false
    },
    {
        border:'transparent',
        background:'#B4A7FB',
        useBackgroundColor:"#B4A7FB",
        useDarkBackgroundColor:'#B4A7FB',
        isSelected:false
    },
    {
        border:'transparent',
        background:'#D8D8D8',
        useBackgroundColor:"#D8D8D8",
        useDarkBackgroundColor:'#D8D8D8',
        isSelected:false
    },
    {
        border:'transparent',
        background:'transparent',
        url:'colour.png',
        isSelected:false
    }
]